"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SchemaBase = _interopRequireDefault(require("../Schema/SchemaBase"));

var _PreviewHeader = _interopRequireDefault(require("./PreviewHeader"));

var _PreviewField = _interopRequireDefault(require("./PreviewField"));

require("./SchemaPreview.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const layouts = {
  "document": _PreviewField.default,
  "section": _PreviewField.default,
  "block": _PreviewField.default,
  "fieldset": _PreviewField.default,
  "field": _PreviewField.default,
  "module": _PreviewField.default,
  "media": _PreviewField.default
};

class SchemaPreview extends _react.Component {
  render() {
    const _this$props = this.props,
          schema = _this$props.schema,
          formData = _this$props.formData,
          formContext = _this$props.formContext;
    const currentLocale = formContext.currentLocale;
    let fieldType;

    if (formData && formData.documentType) {
      fieldType = "document";
    } else if (formData && formData.mediaType) {
      fieldType = "media";
    }

    return _react.default.createElement("div", {
      className: "admin-preview  admin-preview--schema",
      "data-type": fieldType
    }, _react.default.createElement(_PreviewHeader.default, _extends({}, formData, {
      currentLocale: currentLocale
    })), _react.default.createElement(_SchemaBase.default, {
      schema: schema,
      formData: formData,
      formContext: formContext,
      layouts: layouts
    }));
  }

}

_defineProperty(SchemaPreview, "defaultProps", {
  schema: {},
  formData: {},
  formContext: {
    languages: ["en"],
    currentLocale: "en"
  }
});

var _default = SchemaPreview;
exports.default = _default;
module.exports = exports.default;